import React from "react";
import { SearchIcon } from "@cmp-src/icons/icons";
import { Button } from "@cmp-src/primitives/button";
import { useGlobalSearch } from "@/features/global-search/GlobalSearchProvider";
import { getControlKey } from "../../../../../../../packages/helpers/src/os-helpers";
import { useMap } from "@/features/map/MapProvider";

export interface SearchNoResultsProps {
  target?: string;
  searchText?: string;
  floorName?: string;
}

export const MapFiltersCardSearchNoResults: React.FC<SearchNoResultsProps> = ({
  target = "results",
  searchText = "",
  floorName = ""
}) => {
  const { open } = useGlobalSearch();
  const { currentOffice, startDate, endDate, timeMode } = useMap();

  const handleGlobalSearchClick = () => {
    open(searchText, {
      officeId: currentOffice?.id,
      date: startDate,
      endDate,
      timeMode
    });
  };

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6">
      <div className="rounded-xl bg-neutral-100 p-2">
        <SearchIcon className="size-8 transform text-neutral-500" />
      </div>

      <div className="text-center">
        <h3 className="font-semibold text-lg text-neutral-900">
          No Results Found
        </h3>
        {searchText && (
          <p className="mt-2 text-neutral-600 text-sm">
            No available {target} found on {floorName} match "{searchText}" for
            the selected time.
          </p>
        )}
      </div>

      <Button
        onClick={handleGlobalSearchClick}
        variant="default"
        size="sm"
        className="mt-2 gap-2 py-2"
      >
        <SearchIcon className="size-4" />
        Try Global Search
      </Button>

      <div className="flex items-center gap-2 text-neutral-500 text-xs">
        <span>Or press</span>
        <kbd className="rounded border border-neutral-300 bg-neutral-50 px-2 py-1 font-mono text-xs">
          {getControlKey()}
        </kbd>
        <kbd className="rounded border border-neutral-300 bg-neutral-50 px-2 py-1 font-mono text-xs">
          K
        </kbd>
      </div>
    </div>
  );
};
